import { toast } from 'react-toastify';
import { copyTextToClipboard } from '../../shared/copyTextToClipboard';
import { IPropertyAddress, propertyAddressToString } from '../../../ui-toolkit/orders/interfaces/IPropertyAddress';

export const copyAddressToClipboard = (address: IPropertyAddress): void => {
  const propertyAddressString = propertyAddressToString(address);
  copyTextToClipboard(propertyAddressString).then(() => {
    toast('Copied!', { type: 'success' });
  });
};
